import React from 'react';
import PropTypes from 'prop-types';

import { useMessages } from '../i18n';

// The course tabs as a vertical list on the left of every course page, like
// the account settings menu (patched into LoadedTabPage by
// thervumitra/patch-learning.js in place of the tab bar). Phones: a row that
// scrolls sideways (theme).
const CourseSideNav = ({ tabs, activeTabSlug }) => {
  const t = useMessages();
  return (
    <nav className="bm-course-nav" aria-label={t.lhCourseNav}>
      <ul>
        {tabs.map(tab => {
          const active = tab.slug === activeTabSlug;
          return (
            <li key={tab.slug}>
              <a href={tab.url} className={active ? 'is-active' : undefined} aria-current={active ? 'page' : undefined}>
                {tab.title}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

CourseSideNav.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string, title: PropTypes.string, url: PropTypes.string,
  })).isRequired,
  activeTabSlug: PropTypes.string,
};
CourseSideNav.defaultProps = { activeTabSlug: undefined };

export default CourseSideNav;
